<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Clinic Settings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Clinic Settings",
            items: [
               {
                  text: "Clinics",
                  href: "/clinics",
               },  
               {
                  text: "Clinic Settings",
                  active: true,
               },                   
            ],

            settings: [],            
            modules: [],
            sub_admin_modules: [],
            all_modules: [],
            sub_admin: [],

            pagination: {},
            
            selected:[],
            
            keyword: "",
            listing_length: 15,
            status: '',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
         this.fetchSubAdminModules();
      },

      methods: {

         fetchSubAdminModules(page_url = null) {
            this.getToken();

            let url =
            "api/admin/clinics/modules?id=" +
            this.$route.params.id +
            "&keyword=" +
            this.keyword +
            "&limit=" +
            this.listing_length;
               page_url = page_url || url;

                  if(localStorage.back_url) {
                     page_url = localStorage.back_url;  
                     localStorage.removeItem('back_url');
                  }    

                  this.active_page_url = page_url;
                  this.loading = true;
                     this.$axios
            .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               if (res.status == 200) {
                  var responseData = res.data.data;
                  // console.log(responseData);
                  this.sub_admin_modules = responseData.subadmin_modules;
                  //console.log(this.sub_admin_modules);
                  this.selected = [];

                  for (var i = 0; i < this.sub_admin_modules.length; i++) {
                  
                  
                     this.selected.push(
                        this.sub_admin_modules[i].module_id
                        
                     );
                  }
                  
                        this.sub_admin = responseData.sub_admin;

                        this.all_modules = responseData.all_modules.data;
                     
                  // console.log(this.all_modules);
               }
            })
            .catch((error) => {
               console.log(error);
               console.log(error.response);
               if (error.response) {
                  if (error.response.status == 422) {
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  }
                  this.$swal("", error.response.statusText, "error");
                  } else if (error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
                  } else if (error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                  } else {
                  this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            });
            //.finally(() => (this.loading = false));
         },

         getToken() {
         if (localStorage.getItem('sigohealth_admin')) {
            var sigohealth_admin =  JSON.parse(localStorage.getItem('sigohealth_admin'));
            if(sigohealth_admin.token) {
               this.token = sigohealth_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },
         updateSubAdminModules(selected) {
            this.getToken();
            this.errors = {};

            const config = {
            headers: {
               "Content-type": "multipart/form-data",
               Accept: "application/json",
               Authorization: "Bearer " + this.token,
            },
            };

            let url = "api/admin/clinics/module_add";

            let formData = new FormData();

            formData.append("id", this.$route.params.id);
            var i = 0;
            selected.forEach((obj) => {
            formData.append("modules[" + i + "]", obj);
            i++;
            });

            this.$axios
            .post(url, formData, config)
            .then((res) => {
               if (res.status == 200) {
                  this.$swal("", "Modules updated", "success");
                  this.fetchSubAdminModules();
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

               // console.log(res);
            })
            .catch((error) => {
               if (error.response) {
                  if (error.response.status == 422) {
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                     // console.log(this.errors);
                  }
                  this.$swal("", error.response.statusText, "error");
                  } else if (error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
                  } else if (error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                  } else {
                  this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", error.message, "error");
               }
            })
            .finally(() => (this.loading = false));
         },

         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'clinics' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <div class="row" v-if="sub_admin">
                     <div class="col-12">
                        <b-media class="mb-4">
                           <b-media-body class="">
                              <h5 class="mt-1 mb-1" >{{sub_admin.name}}</h5>
                              <!-- <p>
                                 {{sub_admin.email}}
                              </p> -->
                           </b-media-body>
                        </b-media>
                     </div>
                  </div> 

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <!---
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchSubAdminModules()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                           -->
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter text-end">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchSubAdminModules()"/>
                           </label>
                        </div>                     
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>SI No.</th>   
                              <th>Module</th>
                              <th>Permission</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(all_modules.length)">
                           <tr v-for="(all_module, index) in all_modules"
                           :key="index">
                              <td v-if="index !== 0">{{ index }}</td>
                              <td v-if="index !== 0">{{ all_module.module }}</td>
                              <td v-if="index !== 0">
                                 <div class="form-check font-size-16">
                                    <input
                                       class="form-check-input"
                                       type="checkbox"
                                       :value="all_module.id"
                                       name="" v-model="selected"
                                       id="check1"
                                    />
                                    <label
                                       class="form-check-label"
                                       :for="check1"
                                    ></label>
                                 </div>
                              </td>
                           </tr>

                           
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="3" class="text-center">
                              No subadmin modules found
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <div class="row mt-3">
                        <div class="12">
                           <button class="btn btn-primary me-2" type="submit" @click="updateSubAdminModules(selected)">Update</button>
                           <router-link :to="{ name: 'clinics' }" class="btn btn-light">Cancel</router-link>
                        </div>
                     </div>
                  <!----pagination starts 
                  
                  <caption v-if="Boolean(all_modules.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchSubAdminModules(page.url + '&limit='+ listing_length + '&keyword=' + keyword +'&id=' + $route.params.id )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  pagination ends --->       
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
